// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.user-table-row {
  width: 100%;
  height: fit-content;
  display: grid;
  grid-template-columns: 5% 3% 22% 25% 25% 20%;
  flex-direction: row;
  border-bottom: 0.7px solid #DBDBDB;
  justify-content: space-between;
  align-items: self-start;
  padding: 10px 1rem;
  place-items: center;
  font-size: 0.9rem;
}
.user-table-row__photo {
  height: fit-content;
}
.user-table-row > div:not(:first-child) {
  width: 100%;
  display: flex;
  justify-content: start;
}
.user-table-row__info {
  padding-left: 0.75vw;
  display: flex;
  flex-direction: column;
  gap: 0.75vh;
}
.user-table-row__info__name {
  color: black;
  font-weight: 500;
  font-size: 0.85rem;
}
.user-table-row__info__address {
  color: #828282;
  font-size: 0.8rem;
}
.user-table-row__shops {
  display: flex;
  flex-direction: column;
  gap: 0.3vh;
}
.user-table-row__shops__one::before {
  content: "• ";
}
.user-table-row .active {
  color: #806EE8;
}
.user-table-row .not-active {
  color: red;
}
.user-table-row .p-chip {
  border-radius: 3px;
  font-size: 0.85rem;
  padding: 0 15px;
  width: 75% !important;
  background-color: #E3E0FF;
}
.user-table-row__delete-btn {
  color: #4F4BFF;
}`, "",{"version":3,"sources":["webpack://./src/features/profile/components/user-table-row/user-table-row.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,WAAA;EACA,mBAAA;EACA,aAAA;EACA,4CAAA;EACA,mBAAA;EACA,kCAAA;EACA,8BAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AAEJ;AADI;EACI,mBAAA;AAGR;AAAQ;EACI,WAAA;EACA,aAAA;EACA,sBAAA;AAEZ;AACI;EACI,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AACR;AAAQ;EACI,YAAA;EACA,gBAAA;EACA,kBAAA;AAEZ;AAAQ;EACI,cAAA;EACA,iBAAA;AAEZ;AACI;EACI,aAAA;EACA,sBAAA;EACA,UAAA;AACR;AACQ;EACI,aAAA;AACZ;AAEI;EACI,cAAA;AAAR;AAEI;EACI,UAAA;AAAR;AAEI;EACI,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;AAAR;AAEI;EACI,cAAA;AAAR","sourcesContent":[".user-table-row{\n    width: 100%;\n    height: fit-content;\n    display: grid;\n    grid-template-columns: 5% 3% 22% 25% 25% 20%; \n    flex-direction: row;\n    border-bottom: 0.7px solid #DBDBDB;\n    justify-content: space-between;\n    align-items: self-start;\n    padding: 10px 1rem;\n    place-items: center;\n    font-size: 0.9rem;\n    &__photo{\n        height: fit-content;\n    }\n    >div{\n        &:not(:first-child){\n            width: 100%;\n            display: flex;\n            justify-content: start;\n        }\n    }\n    &__info{\n        padding-left: 0.75vw;\n        display: flex;\n        flex-direction: column;\n        gap: 0.75vh;\n        &__name{\n            color: black;\n            font-weight: 500;\n            font-size: 0.85rem;\n        }\n        &__address{\n            color: #828282;\n            font-size: 0.8rem;\n        }\n    }\n    &__shops{\n        display: flex;\n        flex-direction: column;\n        gap: 0.3vh;\n\n        &__one::before{\n            content: \"• \";\n        }\n    }\n    .active{\n        color: #806EE8;\n    }\n    .not-active{\n        color: red;\n    }\n    .p-chip{\n        border-radius: 3px;\n        font-size: 0.85rem;\n        padding: 0 15px;\n        width: 75% !important;\n        background-color:#E3E0FF ;\n    }\n    &__delete-btn{\n        color: #4F4BFF;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
